'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotFitIcon = function PlotFitIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M1.313 19.313c0 1.5 1.188 2.688 2.688 2.688s2.688-1.188 2.688-2.688c0-1.438-1.188-2.625-2.688-2.625s-2.688 1.188-2.688 2.625zM9.313 8c0 1.5 1.188 2.688 2.688 2.688S14.689 9.5 14.689 8c0-1.5-1.188-2.688-2.688-2.688S9.313 6.5 9.313 8zm16 4.688c0 1.438 1.188 2.625 2.688 2.625s2.688-1.188 2.688-2.625c0-1.5-1.188-2.688-2.688-2.688s-2.688 1.188-2.688 2.688zm-8 11.312c0 1.5 1.188 2.688 2.688 2.688S22.689 25.5 22.689 24c0-1.5-1.188-2.688-2.688-2.688S17.313 22.5 17.313 24zM32 22.688L0 13.313v-4l32 9.375z' })
    );
};

exports.default = PlotFitIcon;